import React from "react";
import { Card, Button } from "../../../../common";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
export const RegisterNow = () => {
  const navigate = useNavigate();

  const { isLoggedIn } = useSelector((state) => state.auth);

  const handleRegister = () => {
    navigate("/sign-up");
  };
  return (
    <Card classes="px-6 py-8 bg-footer text-left rounded-xl">
      <div className="flex flex-col sm:flex-row">
        <div className="w-[100%] sm:w-[70%]">
          <h2 className="text-white text-f24 pb-3">
          Create Your Own Business Profile
          </h2>
          <p className="text-left text-white text-f16 mb-2">
          Join our business community and expand your reach starting today!
          </p>
        </div>
        <div className="w-[100%] sm:w-[30%] flex items-center justify-center">
          {(isLoggedIn)?(
            <Link className="bg-primary w-full  sm:w-auto rounded py-3 px-6 text-white" to={"/sign-up"} state={{ redirectToStep: 6 }}>Create Now</Link>
          ):(
            <Link className="bg-primary w-full  sm:w-auto rounded py-3 px-6 text-white" to={"/login"} >Create Now</Link>
          )}
          
        </div>
      </div>
    </Card>
  );
};
